<script setup lang="ts">
	export interface DoughnutLabelContext {
		backgroundColor: string
		title: string
		value?: string | number
	}
	defineProps<DoughnutLabelContext>()
	const { format } = useCurrency()
</script>

<template>
	<div class="flex cursor-pointer flex-col even:items-end">
		<div class="flex gap-2">
			<div class="mt-[5px] h-[6px] w-[6px] shrink-0 rounded-full" :style="{ backgroundColor }" />
			<div class="flex flex-col gap-[5px]">
				<span class="text-[12px] font-medium leading-4 text-gray-600">{{ title }}</span>
				<span v-if="value" class="text-[14px] font-medium leading-4 text-gray-700">{{
					format(Number(value || 0))
				}}</span>
			</div>
		</div>
	</div>
</template>
